export const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const apiUrl = baseUrl + "/api";
export const outerPages = ["/", "/login", "/workspaces", "/workspaces/", "/permission-denied", "/permission-denied/", "/token/", "/forgot-password", "/forgot-password/"];
